(function () {
  'use strict';

  class EddCalculator {
    constructor(root) {
      this.root = root;
      this.isRabitat = root.hasAttribute('data-product-pincode');
      this.pincodeAlwaysVisible = this.isRabitat && (
        root.hasAttribute('data-pincode-always-visible') ||
        !root.hasAttribute('hidden')
      );
      this.productPage = root.closest('[data-product-page]');
      this.form = root.querySelector('.edd-calculator__form');
      this.input = root.querySelector('.edd-calculator__input');
      this.message = root.querySelector('.edd-calculator__message');
      this.errorEl = root.querySelector('[data-product-pincode-error]');
      this.button = root.querySelector('.edd-calculator__button');
      this.apiUrl = (root.dataset.apiUrl || '').trim();
      this.pickupPincode = root.dataset.pickupPincode || '121004';
      this.weight = parseFloat(root.dataset.weight) || 0.5;
      this.cod = root.dataset.cod === 'true';
      this.deliveryLabel = root.dataset.deliveryLabel || 'Free delivery';
      this.storageKey = 'edd_delivery';
      this.legacyStorageKey = 'edd_pincode';
      this.lastCheckedPincode = '';
      this.savedDeliveryDate = '';
      this.requestId = 0;
      this.timelineDate =
        this.productPage && this.productPage.querySelector('[data-product-timeline-delivery-date]');
      this.pincodeToggle =
        this.productPage && this.productPage.querySelector('[data-product-pincode-toggle]');

      if (this.apiUrl.startsWith('/')) {
        this.apiUrl = window.location.origin + this.apiUrl;
      }

      this.bindEvents();
      this.prefillPincode();
    }

    bindEvents() {
      if (!this.form || !this.input) return;

      this.form.addEventListener('submit', function (event) {
        event.preventDefault();
        this.checkDelivery();
      }.bind(this));

      this.input.addEventListener('input', function () {
        var pincode = this.input.value.replace(/\D/g, '').slice(0, 6);
        this.input.value = pincode;

        if (pincode !== this.lastCheckedPincode) {
          this.hideMessage();
          this.resetTimelineDate();
        }

        if (pincode.length === 6 && (!this.isRabitat || !this.root.hidden)) {
          this.checkDelivery();
          return;
        }

        if (pincode.length < 6) {
          this.hideMessage();
        }
      }.bind(this));
    }

    getSavedDelivery() {
      try {
        var raw = localStorage.getItem(this.storageKey);
        if (raw) {
          return JSON.parse(raw);
        }

        var legacyPincode = localStorage.getItem(this.legacyStorageKey);
        if (legacyPincode && /^[1-8][0-9]{5}$/.test(legacyPincode)) {
          return { pincode: legacyPincode };
        }
      } catch (e) {
        return null;
      }

      return null;
    }

    saveDelivery(pincode, deliveryDate) {
      var payload = {
        pincode: pincode,
        deliveryDate: deliveryDate,
        timelineDate: this.formatTimelineDate(deliveryDate)
      };

      localStorage.setItem(this.storageKey, JSON.stringify(payload));
      localStorage.setItem(this.legacyStorageKey, pincode);
      document.dispatchEvent(new CustomEvent('rabitat:edd:updated', { detail: payload }));
    }

    resetTimelineDate() {
      if (!this.timelineDate) return;
      var defaultDate = this.timelineDate.getAttribute('data-default-date');
      if (defaultDate) {
        this.timelineDate.textContent = defaultDate;
      }
    }

    openPanel() {
      if (!this.isRabitat) return;
      this.root.hidden = false;
      if (this.pincodeToggle) {
        this.pincodeToggle.setAttribute('aria-expanded', 'true');
      }
    }

    prefillPincode() {
      var saved = this.getSavedDelivery();
      if (!saved || !saved.pincode || !/^[1-8][0-9]{5}$/.test(saved.pincode) || !this.input) {
        return;
      }

      this.input.value = saved.pincode;
      this.lastCheckedPincode = saved.pincode;

      if (saved.deliveryDate) {
        this.savedDeliveryDate = saved.deliveryDate;
        this.setSuccessMessage(saved.deliveryDate);
      }

      if (this.isRabitat) {
        if (this.pincodeAlwaysVisible) {
          this.root.hidden = false;
          if (saved.deliveryDate) {
            this.setSuccessMessage(saved.deliveryDate, true);
          } else {
            this.checkDelivery();
          }
          return;
        }

        this.root.hidden = true;
        if (this.pincodeToggle) {
          this.pincodeToggle.setAttribute('aria-expanded', 'false');
        }
        return;
      }

      if (!saved.deliveryDate) {
        this.checkDelivery();
      }
    }

    hideMessage() {
      if (!this.message) return;
      this.message.hidden = true;
      this.message.textContent = '';
      this.message.innerHTML = '';
      this.message.className = this.isRabitat
        ? 'rabitat-product-page__pincode-result edd-calculator__message'
        : 'edd-calculator__message';

      if (this.errorEl) {
        this.errorEl.hidden = true;
        this.errorEl.textContent = '';
      }
    }

    setMessage(text, type) {
      this.hideMessage();

      if (this.isRabitat && type === 'error' && this.errorEl) {
        this.errorEl.hidden = false;
        this.errorEl.textContent = text;
        return;
      }

      if (!this.message) return;
      this.message.hidden = false;
      this.message.textContent = text;
      this.message.className = 'edd-calculator__message edd-calculator__message--' + type;
    }

    ordinalSuffix(day) {
      if (day >= 11 && day <= 13) return 'th';
      switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    }

    formatTimelineDate(label) {
      var match = String(label).match(/(\d{1,2})\s+([A-Za-z]{3})/);
      if (!match) return label;
      return match[2] + ' ' + match[1] + this.ordinalSuffix(parseInt(match[1], 10));
    }

    updateTimelineDate(deliveryDate) {
      if (!this.timelineDate || !deliveryDate) return;
      this.timelineDate.textContent = this.formatTimelineDate(deliveryDate);
    }

    setSuccessMessage(deliveryDate, keepVisible) {
      this.hideMessage();
      if (!this.message) return;

      this.message.hidden = keepVisible === true ? false : this.isRabitat && this.root.hidden && !this.pincodeAlwaysVisible;
      this.savedDeliveryDate = deliveryDate;

      if (this.isRabitat) {
        this.message.className = 'rabitat-product-page__pincode-result edd-calculator__message edd-calculator__message--success';
        this.message.innerHTML =
          '<p class="rabitat-product-page__pincode-message">' +
          '<span class="rabitat-product-page__pincode-message-accent">' + this.deliveryLabel + '</span>' +
          ' | By ' + deliveryDate +
          '</p>';
        this.updateTimelineDate(deliveryDate);
        return;
      }

      this.message.hidden = false;
      this.message.className = 'edd-calculator__message edd-calculator__message--success';
      this.message.innerHTML =
        '<span class="edd-calculator__delivery-badge">' + this.deliveryLabel + '</span>' +
        '<span class="edd-calculator__separator" aria-hidden="true"> | </span>' +
        '<span class="edd-calculator__delivery-date">By ' + deliveryDate + '</span>';
    }

    checkDeliveryViaApi(pincode) {
      var self = this;
      var requestId = ++this.requestId;
      this.button.disabled = true;

      var params = new URLSearchParams({
        pincode: pincode,
        pickup_pincode: this.pickupPincode,
        weight: String(this.weight),
        cod: this.cod ? '1' : '0'
      });

      fetch(this.apiUrl + '?' + params.toString())
        .then(function (response) {
          if (!response.ok) {
            throw new Error('API request failed (' + response.status + ')');
          }
          return response.json();
        })
        .then(function (data) {
          if (requestId !== self.requestId) return;

          if (!data.success) {
            throw new Error(data.message || 'Unable to check delivery for this pincode.');
          }

          var label = data.delivery_label || data.delivery_date;
          self.lastCheckedPincode = pincode;
          self.saveDelivery(pincode, label);
          self.setSuccessMessage(label, true);
        })
        .catch(function () {
          if (requestId !== self.requestId) return;
          self.setMessage('Unable to fetch live delivery date. Please try again.', 'error');
        })
        .finally(function () {
          if (requestId === self.requestId && self.button) {
            self.button.disabled = false;
          }
        });
    }

    checkDelivery() {
      var pincode = this.input.value.trim();

      if (!/^[1-8][0-9]{5}$/.test(pincode)) {
        if (pincode.length === 6) {
          this.setMessage('Please enter a valid 6-digit Indian pincode.', 'error');
        }
        return;
      }

      if (this.isRabitat && this.root.hidden) {
        return;
      }

      var saved = this.getSavedDelivery();
      if (saved && saved.pincode === pincode && saved.deliveryDate) {
        this.lastCheckedPincode = pincode;
        this.setSuccessMessage(saved.deliveryDate, true);
        return;
      }

      if (pincode === this.lastCheckedPincode && this.message && !this.message.hidden) {
        return;
      }

      if (this.apiUrl) {
        this.checkDeliveryViaApi(pincode);
      }
    }
  }

  function revealPincodeResult(panel) {
    if (!panel) return;
    var result = panel.querySelector('[data-product-pincode-result]');
    var input = panel.querySelector('.edd-calculator__input');
    if (result && input && input.value.length === 6 && result.innerHTML.trim()) {
      result.hidden = false;
    }
  }

  function initCalculators() {
    document.querySelectorAll('.edd-calculator').forEach(function (root) {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      new EddCalculator(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCalculators);
  } else {
    initCalculators();
  }

  document.addEventListener('shopify:section:load', initCalculators);

  window.RabitatEdd = {
    revealPincodeResult: revealPincodeResult
  };
})();
